import NarrativeEventContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/NarrativeEventContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import TransitionEvent from "../events/TransitionEvent";

export default class TransitionCommand extends AbstractCommand {
    constructor(dispatcher) {
        super(dispatcher);
    }

    execute(evt) {
        const data = evt.params.data;

        /** @type {NarrativeEventContent} */
        this._content = data.content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = data.contentPlayer;

        this._handleCloseBound = this._handleClose.bind(this);
        this._dispatcher.addEventListener(TransitionEvent.CLOSE_REQUEST, this._handleCloseBound);

        this._screenSkin = this.openScreen(SkinKeyRegistry.TRANSITION_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            content: this._content,
        });
    }

    _handleClose() {
        this._dispatcher.removeEventListener(TransitionEvent.CLOSE_REQUEST, this._handleCloseBound);

        this.closeScreen(this._screenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._contentPlayer.contentCompleted(this._content);
    }
}